<div mat-dialog-title class="title-and-close">
  <h1 class="unsaved-changes-title">{{ data.title }}</h1>
  <button mat-button class="cancel-btn" (click)="onCancelClick()">CLOSE</button>
</div>
<div mat-dialog-content>
  <p>{{ data.description }}</p>
</div>
<div class="unsaved-changes-actions" mat-dialog-actions>
  <button
    mat-raised-button
    data-id="ViewAndGroupModalConfirmChanges.Save"
    class="save-btn"
    (click)="onSaveClick()"
  >
    SAVE
  </button>
  <button
    mat-raised-button
    data-id="ViewAndGroupModalConfirmChanges.Discard"
    (click)="onDiscardClick()"
  >
    DISCARD
  </button>
</div>
